import type { ApiPreferredListingType } from '#/api/types/ApiPreferredListingType';
import type { ApiOrgId } from '#/api/types/ApiTypedId';
import type { ApiOrgSize } from '#/modules/listing/orgs/api/types/ApiOrgSize';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { OrgDashboardApiOrg } from './types/OrgDashboardApiOrg';

type ApiResponse = {
  org: OrgDashboardApiOrg;
  user: {
    preferredListingTypes: ApiPreferredListingType[] | null;
    orgSize: ApiOrgSize | null;
  };
};

function mapResponse(data: ApiResponse) {
  return data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) => `/data/orgdashboard/${orgId}/organization`,
  mapResponse,
});

// Exports

export const orgDashboardApiFetchOrg = endpoint.createClientFetchFn();

export const orgDashboardApiIsomorphicFetchOrg =
  endpoint.createIsomorphicFetchFn();
